import { Container, Spinner } from "react-bootstrap"

const Loading = () => {
	return (
		<div className="w-100 h-100">
			<Container className="text-center p-2">
				<Spinner animation="border" role="status" />
			</Container>
		</div>
	)
}

export default Loading
